"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOskarInfo = exports.triggerSnowplowToOskarMappingEvent = void 0;
/***
 * This function is used to trigger an event to Oskar when a user has a Snowplow cookie.
 * It will eventually be depreciated when we shutter Oskar.
 */
const triggerSnowplowToOskarMappingEvent = (domainUserId, domainSessionId) => {
    if (!(window === null || window === void 0 ? void 0 : window.OskarTS))
        return;
    window.OskarTS.capture("oskar_snowplow_mapping_event", {
        snowplow_native_domain_user_id: domainUserId,
        snowplow_native_domain_session_id: domainSessionId
    });
};
exports.triggerSnowplowToOskarMappingEvent = triggerSnowplowToOskarMappingEvent;
const getOskarInfo = () => {
    const sessionExp = new RegExp("(oskar_session=[a-f0-9]*)(.*?)([;])");
    const sessionCookie = document.cookie.match(sessionExp);
    const idExp = new RegExp("(oskar_id=[a-f0-9]*)(.*?)([;])");
    const idCookie = document.cookie.match(idExp);
    if (sessionCookie && idCookie) {
        const sessionInfo = JSON.parse(decodeURIComponent(sessionCookie[2]));
        const idInfo = JSON.parse(decodeURIComponent(idCookie[2]));
        return {
            id: idInfo,
            session: sessionInfo.id,
        };
    }
    return null;
};
exports.getOskarInfo = getOskarInfo;
